import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  post(e) {
    e?.preventDefault();

    sweetAlertConfirmBox(this.element.dataset.confirmMsg)
      .then((value) => value && this.post_records())
  }

  async post_records() {
    console.log('POSTING')
    this.element.classList.add('loading', 'js-disabled');

    const response = await post(this.url, {'responseKind': 'json'});
    console.log(response)

    if (response.ok) {
      greenPOS.notify_success("All filtered records posted to ledger.");

      setTimeout(() => this.refresh(), 2000);
    } else {
      this.element.classList.remove('loading', 'js-disabled');
    }
  }

  refresh() {
    Turbo.visit(window.location.href, {action: 'replace'})
  }
  get url() {
    return this.element.href;
  }
}
